// extracted by mini-css-extract-plugin
export default {"publishingTable":"RzoG8WiPD8XsgTYWRrH7","headerChanges":"HEzJhpSfthcxj5TPd5uk"};